import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("bpj_token")) { setUser(null); setReady(true); return null; }
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; }
    catch { localStorage.removeItem("bpj_token"); setUser(null); return null; }
    finally { setReady(true); }
  }, []);

  useEffect(() => {
    // Returning from social sign-in: AuthCallback establishes the session first.
    const h = window.location.hash || "";
    if (h.includes("session_id=") || h.includes("login_code=")) { setReady(true); return; }
    refresh();
  }, [refresh]);

  const acceptSession = useCallback((data) => {
    localStorage.setItem("bpj_token", data.token);
    setUser(data);
    setReady(true);
  }, []);

  const signIn = async (path, body) => {
    const { data } = await api.post(path, body);
    localStorage.setItem("bpj_token", data.token);
    setUser(data);
    return data;
  };
  const login = (email, password) => signIn("/auth/login", { email, password });
  const register = (name, email, password) => signIn("/auth/register", { name, email, password });
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("bpj_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, ready, login, register, logout, refresh, acceptSession }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
